import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { RestResponse } from 'src/app/shared/model/rest-response';
import { RestService } from 'src/app/shared/service/rest.service';
import { switchMap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class VehicleLayoutDictionaryService extends RestService {

    private layoutDictionaryMap: Map<string, VehicleLayoutDictionaryEntry[]>;
    private sideNumberKeyMap: SideNumberDictionaryKeyMap = {};
    private loaded: boolean = false;

    loadVehicleLayoutDictionaries(): Observable<void> {
        const subject = new Subject<void>();
        this.getVehicleLayoutDictionaries().pipe(switchMap(response => {
            this.layoutDictionaryMap = new Map<string, VehicleLayoutDictionaryEntry[]>();
                response.data.forEach(dictionary => {
                        this.layoutDictionaryMap.set(dictionary.name, dictionary.dictionaryEntries);
                    }
                );
            return this.getSideNumberDictionaryKeyMap(Array.from(this.layoutDictionaryMap.keys()));
        }))
        .subscribe(
            keyMap => {
                this.sideNumberKeyMap = keyMap;
                this.loaded = true;
                subject.next();
                subject.complete();
            },
            error => {
                console.error(error);
                subject.error(error);
                subject.complete();
            });
        return subject;
    }

    private getSideNumberDictionaryKeyMap(dictionaryKeys: string[]): Observable<SideNumberDictionaryKeyMap> {
        return this.doPost<SideNumberDictionaryKeyMap>('api/vehicle/layout/dictionary/sidenumberDictionaryKeysMap', dictionaryKeys);
    }

    private getVehicleLayoutDictionaries(): Observable<RestResponse<VehicleLayoutDictionary>> {
        return this.postRequest<VehicleLayoutDictionary>(VehicleLayoutDictionary, 'api/vehicle/layout/dictionary/fetch/all');
    }

    isLoaded(): boolean {
        return this.loaded;
    }

    getDescriptionForValueBySideNumber(sideNumber: string, ip: string): string {
        const key = this.sideNumberKeyMap[sideNumber];
        return key ? this.getDescriptionForValueAndSettingName(key, ip) : ip;
    }

    private getDescriptionForValueAndSettingName(name: string, ip: string): string {
        const address = this.parseIp(ip);

        let returnValue: string;
        if (this.loaded && this.layoutDictionaryMap.has(name.toUpperCase())) {
            const dictionary = this.layoutDictionaryMap.get(name.toUpperCase());
            if (typeof dictionary != 'undefined' && dictionary) {
                dictionary.forEach(value => {
                    if (value.ip === address) {
                        returnValue = value.description;
                    }
                });
            }
        }
        if (typeof returnValue != 'undefined' && returnValue)
            return returnValue;
        else return address;
    }

    private parseIp(value: string): string {
        if (typeof value != 'undefined' && value) {
            return value.startsWith('::ffff:') ? value.replace('::ffff:', '') : value;
        }
    }

}

interface SideNumberDictionaryKeyMap {
    [sideNumber: string]: string;
}

class VehicleLayoutDictionary {
    id: number;
    name: string;
    dictionaryEntries: VehicleLayoutDictionaryEntry[];
}

interface VehicleLayoutDictionaryEntry {
    id: number;
    description: string;
    ip: string;
}
